export const hoursLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const daysOfWeekIndex = [1, 2, 3, 4, 5, 6, 7];
